module.exports = __webpack_public_path__ + "static/media/iOS-chrome-prompt.dde6d711.png";